module.exports = __webpack_public_path__ + "img/start.894f1842.svg";